/* loaded by smart-asset */
export default require("./assets/shipping-label.i.svg")